import { Box } from "@mui/material";
import { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CommonStyle } from "Components";
import RouteFallback from "RouteFallback";

const SettingManagement: FC = () => {
  return (
    <Box
      height="91%"
      sx={{ ...CommonStyle.sxWhiteBox, px: 2 }}
      overflow={"auto"}
    >
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};
export default SettingManagement;
